import { ChannelsGroup, GenreGroupType } from '../../types/landing-page';

export interface LandingPageState {
  channelGroups: ChannelsGroup[];
  channelGenreGroups: GenreGroupType[];
  isBundlePlusEnabled: boolean;
  isLoadingLandingPageData: boolean;
  landingPageDataLoaded: boolean;
}

export const CHANNEL_GROUP = {
  title: '',
  channels: [],
};

const initialState: LandingPageState = {
  channelGroups: [],
  channelGenreGroups: [],
  isBundlePlusEnabled: false,
  isLoadingLandingPageData: false,
  landingPageDataLoaded: false,
};

export default initialState;
